import styled, { css } from 'styled-components'

import { isDesktop } from 'utils/device'

export const Wrapper = styled.div`
    width: 100%;
    height: 100%;
`

export const DefaultAvatar = styled.img`
    width: 100%;
    height: 100%;

    ${props =>
        props.withBackground &&
        css`
            background: #fbcc40;
            border-radius: 50%;
        `}
    ${props =>
        props.isTeacher &&
        !isDesktop &&
        css`
            border-radius: 0;
        `}
`
